import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { refreshPostAfterComment } from '../api/libraryPostCache';

import { useUserScope } from '@/hooks/useUserScope';

/** What the post screen hands comments as `onCommentPosted`. */
export function useRefreshPostAfterComment() {
  const queryClient = useQueryClient();

  const { userId } = useUserScope();

  return useCallback(
    (postId: number) => refreshPostAfterComment(queryClient, userId, postId),
    [queryClient, userId]
  );
}
